var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"callback-twitter",attrs:{"element-loading-text":_vm.$t(`message.login.loginLoading`),"element-loading-target":"document.body"}})
}
var staticRenderFns = []

export { render, staticRenderFns }